import { Injectable } from '@angular/core';
import { IConversion } from '../../convert/models/i-conversion';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HeaderArrayToHttpHeadersConversionService implements IConversion<any[], {[key: string]: string}> {

  constructor() { }

  run(source) {
    let headers = {};
    for (const header of source) {
      headers = {
        ...headers,
        ...header
      };
    }
    return headers;
  }
}
